module.exports = __webpack_public_path__ + "img/capa1.9b87db90.webp";